import { TableColumn } from '../../table/DataTable.types';

export const columns: TableColumn[] = [
  {
    accessor: 'userName',
    name: 'page.team-member.col-username',
  },
];
